import { writable, derived } from 'svelte/store'; // Import derived
import type { Data } from '../types';
import { months as monthNames } from '../util'; // Assuming months array is exported from util

export const data = writable<Data[]>([]);
export const currentDate = writable<Date>();
export const currentMonth = writable<number>(); // 0-11 index
export const year = writable<number>();
export const month = writable<string>(); // Full month name like "January"
export const color = writable<string>();

// Derive current month and year as a combined store for convenience
const currentMonthAndYear = derived([currentMonth, year], ([$currentMonth, $year]) => {
  if ($currentMonth === undefined || $year === undefined) {
    return undefined;
  }
  return { currentMonthIndex: $currentMonth, currentYear: $year };
});

// Derive prevMonth details
export const prevMonthInfo = derived(currentMonthAndYear, $currentMonthAndYear => {
  if (!$currentMonthAndYear) {
    return undefined;
  }
  const { currentMonthIndex, currentYear } = $currentMonthAndYear;
  const prevMonthIndex = (currentMonthIndex - 1 + 12) % 12;
  const prevMonthYear = currentMonthIndex === 0 ? currentYear - 1 : currentYear;
  return {
    label: monthNames[prevMonthIndex],
    month: prevMonthIndex,
    year: prevMonthYear,
  };
});

// Derive nextMonth details
export const nextMonthInfo = derived(currentMonthAndYear, $currentMonthAndYear => {
  if (!$currentMonthAndYear) {
    return undefined;
  }
  const { currentMonthIndex, currentYear } = $currentMonthAndYear;
  const nextMonthIndex = (currentMonthIndex + 1) % 12;
  const nextMonthYear = currentMonthIndex === 11 ? currentYear + 1 : currentYear;
  return {
    label: monthNames[nextMonthIndex],
    month: nextMonthIndex,
    year: nextMonthYear,
  };
});
